import { useMutation } from "@apollo/client/react";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useFetchShiftInstances from "hooks/apollo/shiftInstance/useFetchShiftInstances";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import TimeZone from "utils/TimeZone";
import { FullyScheduleWorkOrder } from "./workBlock.gql";

export default function useFullyScheduleWorkOrder() {
  const { refetch: refetchShiftInstances } = useFetchShiftInstances();
  const { setNotification } = useNotificationState();
  const [fullyScheduleWorkOrder] = useMutation(FullyScheduleWorkOrder, {
    onCompleted: () => {
      refetchShiftInstances();
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to fully schedule work block",
          type: "danger",
        });
      });
    },
  });
  const applicationContext = useApplicationContext();

  return (workBlock) => {
    const workBlockId = workBlock.id;

    return fullyScheduleWorkOrder({
      optimisticResponse: {
        fullyScheduleWorkOrder: {
          __typename: "FullyScheduleWorkOrderPayload",
          workBlock,
        },
      },
      variables: {
        efficiencyOverride: workBlock.efficiencyOverride,
        laborOverride: workBlock.laborOverride,
        lineId: workBlock.line.id,
        lockedOnSchedule: workBlock.lockedOnSchedule,
        productionRateOverride: workBlock.productionRateOverride,
        teardownTimeDuration: workBlock.teardownTimeDuration,
        teardownTimeLabel: workBlock.teardownTimeLabel,
        workBlockId,
        workOrderId: workBlock.workOrder.id,
        workTimeEndsAt: TimeZone.overrideZone(workBlock.workTimeEndsAt, applicationContext.timeZone.name),
        workTimeStartsAt: TimeZone.overrideZone(workBlock.workTimeStartsAt, applicationContext.timeZone.name),
      },
    });
  };
}
